/** Prevent another submit from the old-state exception form after its mutation succeeded. */
export function canSubmitException(allowedReasonCount: number, isSubmitting: boolean, submitted: boolean) {
  return allowedReasonCount > 0 && !isSubmitting && !submitted
}
import { UiDeliveryState } from '@/lib/status'
import type { DeliveryState, ExceptionDraft } from '@/types/logistics'

/** The explicit server policy wins, including an empty array for a former holder. */
export function exceptionReasonsFor(role: string | undefined, state: DeliveryState | undefined, codes?: string[]): ExceptionDraft['reason'][] {
  const known = ['recipient_absent', 'refused', 'damaged_at_receipt', 'damaged_at_delivery', 'lost', 'wrong_content', 'unreachable']
  if (codes !== undefined) return codes.map(code => code.toLowerCase()).filter((code): code is ExceptionDraft['reason'] => known.includes(code))
  if (role === 'courier') {
    if (state === UiDeliveryState.Created) return ['damaged_at_receipt']
    if (state === UiDeliveryState.EnRoute || state === UiDeliveryState.ReturnCollected) return ['damaged_at_receipt', 'lost', 'wrong_content']
    return []
  }
  if (role !== 'agent') return []
  if ([UiDeliveryState.PickupReady, UiDeliveryState.ReturnRequested, UiDeliveryState.ReturnDeposited].some(value => value === state)) return ['damaged_at_receipt', 'lost', 'wrong_content']
  if (state === UiDeliveryState.Dropped) return ['damaged_at_receipt']
  if (state === UiDeliveryState.Received) return ['wrong_content', 'lost']
  if (state === UiDeliveryState.OutForDelivery) return ['recipient_absent', 'refused', 'damaged_at_delivery', 'unreachable', 'lost']
  return []
}
